export const TOP_NEWS_ARTCLES_COUNT = 10;
export const NEWS_ARTCLES_COUNT = 5;
export const GAMES_ARTCLES_COUNT = 5;
export const TOP_DEALS_ARTCLES_COUNT = 5;
export const DEALS_FEED_OFFSET = 10;
export const NEWS_FEED_OFFSET = 1;
export const NEWS_VIDEO_FEED_OFFSET = 20;
export const HOME_TOP_NEWS_IMAGES_PRIORITY = 3;
export const HOME_NEWS_CARD_IMAGES_PRIORITY = 1;
export const HOME_GAMES_CARD_IMAGES_PRIORITY = 1;
export const HOME_TOP_DEALS_CARD_IMAGES_PRIORITY = 1;
export const POPULAR_BRANDS_CARD_IMAGES_PRIORITY = 5;
export const POPULAR_BRANDS_LENGTH = 10;
export const GAMES_FEED_OFFSET = 10;
export const GAMES_CATEGORY_OFFSET = 5;
export const GAMES_CATEGORY_LIMIT = 5;
export const MINIMUM_DEALS_IN_BRANDS = 5;

// News Page
export const NEWS_IN_BRIEF_ARTICLES_COUNT = 5;
export const MORPHING_ARTICLES_COUNT = 4;

// Games
export const GAME_OF_THE_DAY_RATING = 4;
export const RECENTLY_PLAYED_GAMES_VIEW_COUNT = 4;

// HomePage
export const IN_VIEWABLE_ZAPP_OFFSET = 2;

export const SENTRY_DSN =
  'https://7ca2b300c3bf412d840ea258334f9138@o1160911.ingest.sentry.io/4505248442941440';

export const SECONDS_IN_A_DAY = 86400;

export const GAMES_HERO_IMAGE_SIZE = '300x300';
export const ACTION_GAMES_HERO_IMAGE_SIZE = '200x200';
export const UTM_MEDIUM = 'utm_medium';
